<agpr-dialog-container
    [id]="id + '.progressDialog'"
    [heading]="headerLabel"
    [showClose]="false"
    styleClass="agpr-progressDialog"
>
    <div class="agpr-progressDialog-content">

        <agpr-message *ngIf="alertMessage" [severity]="alertType">
            {{ alertMessage | localize }}
        </agpr-message>
        @if (showCount) {
            <div class="agpr-progressDialog-countDisplay">
                {{ progress?.currentIndex }} / {{ progress?.totalItems }}
            </div>
        }
        @if (activeStageText) {
            <div class="agpr-progressDialog-generatingText">
                {{ activeStageText | localize }}
            </div>
        }
        <div class="agpr-progressDialog-progressBar">
            <p-progressBar
                [value]="((progress?.currentIndex / progress?.totalItems) * 100)"
                [showValue]="false"
            ></p-progressBar>
        </div>
        @if (showPercentage) {
            <div class="agpr-progressDialog-countDisplay">
                {{ (progress?.currentIndex / progress?.totalItems) * 100 + '%' }}
            </div>
        }
        @if (showCountBottom) {
            <div class="agpr-progressDialog-countDisplay">
                {{ progress?.currentIndex }} / {{ progress?.totalItems }}
            </div>
        }
        <div class="agpr-progressDialog-descriptionLine">
            <span class="agpr-progressDialog-actionKeyword">
                {{ keywordLabel | localize }}
            </span>
            <span class="agpr-progressDialog-currentIndexLabel">
                {{ progress?.currentIndexLabel | localize }}
            </span>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [label]="cancelButtonLabel | localize"
            [style]="buttonTypes.secondary"
            (click)="onCancelClick()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>

